import "./style/bundle-section.scss"

import React, { useEffect, useState } from "react"
import Container from "@modules/shared/Container"
import { useCampaignAdminTagToFindSingleCampaignAndConnectedProducts } from "./hooks/useCampaignAdminTagToFindSingleCampaignAndConnectedProducts"

import LoadingSkeleton from "@modules/shared/LoadingSkeleton"
import BundleSectionHeader from "./BundleSectionHeader"
import BundleSectionBody from "./BundleSectionBody"
import BundleSectionCTA from "./BundleSectionCTA"
import { CampaignDetailsAndProducts, CampaignPageNavigator } from "./types/CampaignAdminTypes"
interface BundleSectionProps {
    campaignAdminTag: string
}

const BundleSection = ({ campaignAdminTag }: BundleSectionProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [bundleSection, setBundleSection] = useState<CampaignDetailsAndProducts | null>(null)
    const [campaignPageNavigator, setCampaignPageNavigator] =
        useState<CampaignPageNavigator | null>(null)

    const { state, data } =
        useCampaignAdminTagToFindSingleCampaignAndConnectedProducts(campaignAdminTag)

    useEffect(() => {
        if (state === "pending") {
            setIsLoading(true)
        } else {
            setIsLoading(false)
        }

        if (data !== null) {
            setBundleSection(data)
            setCampaignPageNavigator({
                campaignName: data.campaignDetails.marketTextLong,
                campaignDescription: "",
                id: [String(data.campaignDetails.campaignId)],
            })
        }
    }, [data, state])

    return (
        <Container
            content="full-width"
            className="bundle-section"
        >
            {isLoading ? <LoadingSkeleton isLoading /> : null}

            {bundleSection !== null &&
            campaignPageNavigator !== null &&
            bundleSection.products.length !== 0 ? (
                <>
                    <BundleSectionHeader
                        title={bundleSection.campaignDetails.marketTextLong}
                        campaignPageNavigator={campaignPageNavigator}
                    />
                    <BundleSectionBody
                        products={bundleSection.products}
                        lastItemCTA={
                            <BundleSectionCTA campaignPageNavigator={campaignPageNavigator} />
                        }
                    />
                </>
            ) : null}
        </Container>
    )
}

export default BundleSection
